<div *ngIf="audienceLookalikeDetails">
    <div class="header-container">
        <coreui-breadcrumbs>
            <a [routerLink]="audiencesRouter" coreUIBreadcrumbLink>Audiences</a>
            <span coreUIBreadcrumbSlash></span>
            <span coreUIBreadcrumbEnd>Lists</span>
        </coreui-breadcrumbs>

        <!-- <coreui-menu buttonLabel="Actions" menuButtonStyle="button" buttonType="primary" verticalPosition="bottom"
            menuAlignment="left">
            <coreui-menu-section>
                <button type="button" coreUIMenuItem>
                    Menu Item
                </button>
            </coreui-menu-section>
        </coreui-menu> -->
    </div>

    <div class="h1">{{audienceLookalikeDetails?.audienceName}}</div>

    <div class="row top-content">
        <div>
            <div class="row top-content-row">
                <div class="title text-style-2">
                    id:
                </div>
                <div>
                    {{audienceLookalikeDetails?.id}}
                </div>
            </div>

            <div class="row top-content-row">
                <div class="title text-style-2">
                    Created:
                </div>
                <div>
                    {{audienceLookalikeDetails?.createdAt | date: "yyyy-MM-dd hh:mm aa"}} by
                    {{audienceLookalikeDetails?.createdBy}}
                </div>
            </div>
        </div>
        <div>
            <div class="row top-content-row">
                <div class="title text-style-2">
                    Source Model:
                </div>
                <div>
                    <a
                        (click)="navigateToLookalikesDetails()">{{audienceLookalikeDetails.lookalikeModel?.modelName}}</a>
                </div>
            </div>

            <div class="row top-content-row">
                <div class="title text-style-2">
                    Status:
                </div>
                <div class="row status-container">
                    <coreui-badge [color]="audienceLookalikeDetails?.audienceStatus === 'COMPLETED' ? 'Lime' : 'Apple'">
                        {{audienceLookalikeDetails?.audienceStatus | titlecase}}
                    </coreui-badge>
                    {{audienceLookalikeDetails?.updatedAt | date: "yyyy-MM-dd hh:mm aa"}}
                </div>
            </div>
        </div>
    </div>

    <div class="explorer-container">
        <lib-lookalike-model-explorer [lookalikeListId]="audienceLookalikeDetails?.lookalikeModel?.id">
        </lib-lookalike-model-explorer>
    </div>
</div>